var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontHips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 59,
    viewBox: "0 0 53 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1397 6.6615C15.9773 7.31714 1.88108 1.08856 1.88108 1.08856C-0.741432 28.9533 1.00237 23.0525 1.98583 33.2149C2.96929 43.3773 1.98588 41.7382 1.65806 47.639C1.33024 53.5397 1.98588 58.457 8.21445 57.8014C14.443 57.1458 16.41 52.2285 17.0656 49.6059C17.5901 47.5079 17.5027 44.3608 17.3934 43.0495C18.0491 39.7713 18.3769 39.7713 20.3438 35.5097C21.9173 32.1003 25.1518 17.9167 26.5724 11.251C27.0298 17.2829 31.3524 29.9367 33.4566 35.5097C35.4235 39.7713 36.407 40.0991 36.407 43.0495C36.407 44.4618 36.407 47.9668 36.7348 49.6059C37.609 52.9934 40.7997 59.3749 46.5694 57.8014C52.339 56.2279 52.6887 50.3708 52.1423 47.639C51.3555 42.6561 51.3774 35.9467 51.4867 33.2149C53.847 18.2663 51.6004 5.24095 50.3984 0.760742C50.3984 0.760742 40.236 5.75206 26.1397 6.6615Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontHips);
export default __webpack_public_path__ + "static/media/FrontHips.047ab2c3ad5619cef88dc84655d2470f.svg";
export { ForwardRef as ReactComponent };